const ITEMS = [
  "100% Breathable Organic Cotton",
  "Free Shipping on Orders Above ₹1,999",
  "Handstitched with Care in Bangalore",
  "Made for Twirls & Cartwheels",
  "Loved by Parents Across India",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-mint border-y border-ink/10 overflow-hidden py-4" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center gap-8 pr-8 whitespace-nowrap">
                <span className="font-serif italic text-lg text-ink">{item}</span>
                <span className="text-terracotta text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
